function ValidateChannel(selectedChannel) {
	var validationErrors = [];                
	if (!selectedChannel.name || selectedChannel.name === '') {                    
		addErrorMessage(validationErrors, 'name', 'Channel name is empty');
	}
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateChannel;